import { createTheme } from "@mui/material/styles";

import { getColor } from "@hooks/useColors";
import background_dark from "@public/about_us/flares_general_dark.png";

import { fontsTheme } from "./fontsTheme";

const initDarkTheme = createTheme(fontsTheme, { palette: { mode: "dark" } });

export const darkTheme = createTheme(initDarkTheme, {
  palette: {
    mode: "dark",
    background: {
      default: getColor(c => c.tokens.bg["weak-50"], initDarkTheme),
      paper: getColor(c => c.tokens.bg["weak-50"], initDarkTheme),
    },
    text: {
      primary: getColor(c => c.tokens.text["strong-950"], initDarkTheme),
      secondary: "#D1D1D1",
    },
  },
  footerBackgroundGradient:
    "radial-gradient(44.06% 50% at 50% 0%, rgba(5, 223, 84, 0.08) 0%, rgba(150, 197, 240, 0.04) 100%)",
  mainContentGradient: "linear-gradient(82deg, #05DF54 0%, #96C5F0 76%)",
  headerLinearGradient: getColor(
    c => c.gradients.headerlineardark,
    initDarkTheme,
  ),
  background: {
    image: background_dark,
  },
  portfolio: {
    header: {
      borderColor_100: "#FFFFFF1A",
      borderColor_200: "#FFFFFF33",
      borderColor_300: "#FFFFFF4D",
    },
  },
});
